import {alias, createModelSchema} from "serializr";
import {Schema} from "@/common/Schema";

import {SmartOfferBundle} from "../bundle-core/SmartOfferBundle";
import {SmartOfferBundleKind} from "../bundle-core/SmartOfferBundleKind";
import {RewardBunch} from "@/modules/redactor/models/reward/RewardBunch";
import {CurrencyKindModel} from "@/modules/redactor/models/currency/CurrencyKindModel";
import {ItemKindModel} from "@/modules/redactor/models/item/core/ItemKindModel";
import {SmartOfferBundleAchievementType} from "./SmartOfferBundleAchievementType";
import {RedactorUtils} from "@/modules/redactor/core/RedactorUtils";
import {RewardTrack} from "@/modules/redactor/models/reward/RewardTrack";

export class SmartOfferBundleAchievement extends SmartOfferBundle {

  constructor() {
    super(SmartOfferBundleKind.ACHIEVEMENT);

    this._type = null;
    this._currency = null;

    this._reward = null;
    this._rewardPremium = null;
    this._trackPrize = null;

    this._productChest = null;
    this._productPremium = null;

    this._itemKind = null;
  }

  get type() {
    return this._type;
  }

  set type(value) {
    this._type = value;
  }

  get currency() {
    return this._currency;
  }

  set currency(value) {
    this._currency = value;
  }

  get reward() {
    return this._reward;
  }

  set reward(value) {
    this._reward = value;
  }

  get rewardPremium() {
    return this._rewardPremium;
  }

  set rewardPremium(value) {
    this._rewardPremium = value;
  }

  get trackPrize() {
    return this._trackPrize;
  }

  set trackPrize(value) {
    this._trackPrize = value;
  }


  get productChest() {
    return this._productChest;
  }

  set productChest(value) {
    this._productChest = value;
  }

  get productPremium() {
    return this._productPremium;
  }

  set productPremium(value) {
    this._productPremium = value;
  }

  get itemKind() {
    return this._itemKind;
  }

  set itemKind(value) {
    this._itemKind = value;
  }


  valid() {
    if (!super.valid()) {
      return false;
    }

    if (!SmartOfferBundleAchievementType.is(this.type)) {
      return false;
    }

    if (!CurrencyKindModel.is(this.currency)) {
      return false;
    }

    if (!this.reward || this.reward.empty()) {
      return false;
    }

    if (this.reward && !this.reward.valid()) {
      return false;
    }

    if (this.rewardPremium && !this.rewardPremium.valid()) {
      return false;
    }


    if (SmartOfferBundleAchievementType.PIGGY.equal(this.type)) {
      this.productChest = null;

      if (!this.productPremium || !RedactorUtils.getProduct(this.productPremium)) {
        return false;
      }

    } else if (SmartOfferBundleAchievementType.SEASON.equal(this.type)) {

      if (!ItemKindModel.is(this.itemKind) || ItemKindModel.isNone(this.itemKind) || ItemKindModel.isAny(this.itemKind)) {
        return false;
      }

      if (!this.productChest || !RedactorUtils.getProduct(this.productChest)) {
        return false;
      }

      if (!this.productPremium || !RedactorUtils.getProduct(this.productPremium)) {
        return false;
      }

      if (this.trackPrize && !this.trackPrize.valid()) {
        return false;
      }

    } else if (SmartOfferBundleAchievementType.BATTLE_PASS.equal(this.type)) {

      if (!this.productChest || !RedactorUtils.getProduct(this.productChest)) {
        return false;
      }

      if (!this.productPremium || !RedactorUtils.getProduct(this.productPremium)) {
        return false;
      }

      this.trackPrize = null;
    } else if (SmartOfferBundleAchievementType.MAIN_QUESTS_V2.equal(this.type)) {
      this.productChest = null;
      this.productPremium = null;
      this.trackPrize = null;
      
    } else if (SmartOfferBundleAchievementType.MAIN_QUESTS.equal(this.type)) {
      this.productChest = null;
      this.productPremium = null;

      if (!this.trackPrize || !this.trackPrize.valid()) {
        return false;
      }

    } else {
      this.productChest = null;
      this.productPremium = null;
    }

    return true;
  }

  empty() {
    if (!this.reward || this.reward.empty()) {
      return true;
    }

    return super.empty();
  }

  clone(target = undefined) {
    if (!target) {
      return super.clone(new SmartOfferBundleAchievement());
    } else if (target instanceof SmartOfferBundleAchievement) {
      return super.clone(target);
    } else {
      console.assert(false);
      return undefined;
    }
  }
}

createModelSchema(SmartOfferBundleAchievement, {
  _type: alias("type", SmartOfferBundleAchievementType.schema()),
  _currency: alias("currency", CurrencyKindModel.schema()),

  _reward: alias("reward", RewardBunch.schema()),
  _rewardPremium: alias("reward_premium", RewardBunch.schema()),

  _trackPrize: alias("track_prize", RewardTrack.schema()),

  _productChest: alias("product_chest", Schema.primitive()),
  _productPremium: alias("product_premium", Schema.primitive()),

  _itemKind: alias("item_kind", ItemKindModel.schema()),
});
